import { ServerActionName } from '@headless-workspace/config';
import { CONTENT_ASSET_KEYS, unwrapResultSuccess } from '@headless-workspace/core-domain';
import { getContentAssetServerAction, HTMLString } from '../../../../../server';
import { getCachedContentAsset } from '../../../contentAssets';
import { useSafeSWR } from '../../../hooks';
import { UserRevalidationKey } from '../../../user';

export const usePriceRegulationAssets = () => {
    const contentAsset = getCachedContentAsset(CONTENT_ASSET_KEYS.PRICE_REGULATION_LEGAL_MENTIONS);

    const { data: swrData, isLoading } = useSafeSWR(
        contentAsset ? null : UserRevalidationKey.ContentAsset,
        ServerActionName.getContentAssetServerAction,
        () => getContentAssetServerAction([CONTENT_ASSET_KEYS.PRICE_REGULATION_LEGAL_MENTIONS]),
        { fallbackData: contentAsset },
    );

    const asset = unwrapResultSuccess(swrData ?? { type: 'empty' });

    return {
        isLoading,
        result:
            asset?.find((element) => element.id === CONTENT_ASSET_KEYS.PRICE_REGULATION_LEGAL_MENTIONS)?.content.html
                .content ?? HTMLString(''),
    };
};
